import React, { lazy } from "react";
import PropTypes from "prop-types";
import { Route, Routes } from "react-router-dom";
import Box from "@mui/material/Box";

// Lazy-loaded views
const OfficialLeagueList = lazy(() => import("./OfficialLeagueList"));
const OfficialCompetitionList = lazy(() => import("./OfficialCompetitionList"));
const OfficialFixtureList = lazy(() => import("./OfficialFixtureList"));

const OfficialLeagues = () => {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Routes>
        <Route path="/" element={<OfficialLeagueList />} />
        <Route path="/:leagueId/competitions" element={<OfficialCompetitionList />} />
        <Route
          path="/:leagueId/competitions/:competitionId/fixtures"
          element={<OfficialFixtureList />}
        />
      </Routes>
    </Box>
  );
};

OfficialLeagues.propTypes = {};

export default OfficialLeagues;
